import { isNil } from 'lodash-es';
import { useRouter } from 'next/router';
import qs from 'query-string';

import useCheckLoginSession from './useCheckLoginSession';

const USER_ID_KEY = 'userId';

export default function useQueryOptionWithPathUserId<T = Record<string, unknown>>(
  apiEndpoint: string,
  queryStringObject?: T,
) {
  const { query } = useRouter();
  const { isAdmin } = useCheckLoginSession();
  const userId = query.id;

  if (isNil(userId) || !isAdmin) {
    return {
      queryKey: [apiEndpoint, queryStringObject],
      url: qs.stringifyUrl({ url: apiEndpoint, query: { ...queryStringObject } }),
    };
  }

  return {
    queryKey: [apiEndpoint, { ...queryStringObject, userId }],
    url: [
      apiEndpoint,
      qs.stringify({
        ...queryStringObject,
        [USER_ID_KEY]: userId,
      }),
    ]
      .filter(Boolean)
      .join('?'),
  };
}
